import { zodResolver } from "@hookform/resolvers/zod";

import { PersonMeta } from "./PersonMeta";
import {
  AppEdit,
  AppFormContent,
  AppFormSection,
  AppSimpleForm,
  SectionHeader,
  AppTextInput,
  AppFormToolbar,
} from "../../layout";
import { personEditFormSchema } from "../schemas";
import { toUpdatePersonCommand } from "../mappers";

function PersonEditFields() {
  return (
    <>
      <AppTextInput source="displayName" label="Name" fullWidth />
      <AppTextInput source="preferredName" label="Rufname" fullWidth />
      <AppTextInput source="mobilePhoneE164" label="Mobil" fullWidth />
      <AppTextInput source="email" label="E-Mail" type="email" fullWidth />
    </>
  );
}

export const PersonEdit = () => (
  <AppEdit aside={<PersonMeta />} transform={toUpdatePersonCommand}>
    <AppSimpleForm
      resolver={zodResolver(personEditFormSchema) as any}
      mode="onBlur"
      toolbar={<AppFormToolbar />}
    >
      <AppFormSection>
        <SectionHeader
          title="Stammdaten"
          subtitle="Persönliche Kontaktdaten."
        />

        <AppFormContent>
          <PersonEditFields />
        </AppFormContent>
      </AppFormSection>
    </AppSimpleForm>
  </AppEdit>
);
